<template>

    <ui-popup v-bind="$componentProps('ui-popup')">

        <ui-date-picker
            v-bind="$componentProps('ui-date-picker')"
            :modelValue="selectedDate" @update:modelValue="onInput"
            @navigate="$emit('navigate', $event)"
        ></ui-date-picker>

    </ui-popup>

</template>

<script lang="ts">

import { Component, Prop, Vue, Watch } from 'vue-facing-decorator';

import type { ComponentProps } from '@wittignl/js-core';
import { componentPropsMixin, createComponentMixin } from '@wittignl/js-core';

import type { PopupProps } from './Popup.vue';
import Popup, { popupCompMixin } from './Popup.vue';

import type { DatePickerProps } from '../control/DatePicker.vue';
import DatePicker, { datePickerCompMixin } from '../control/DatePicker.vue';

@Component({
    name: 'ui-date-picker-popup',
    components: {
        'ui-popup': Popup,
        'ui-date-picker': DatePicker
    },
    mixins: [componentPropsMixin, popupCompMixin, datePickerCompMixin],
    emits: ['dismiss', 'update:modelValue', 'navigate']
})
export default class DatePickerPopup extends Vue {

    @Prop({ type: [String, Array] })
    modelValue: string | string[];

    @Prop({ type: Boolean, default: true })
    autoClose: boolean;

    selectedDate: string | string[] = null;

    created() {

        this.selectedDate = this.modelValue;
    }

    @Watch('modelValue')
    onModelValueUpdate(value) {

        this.selectedDate = value;
    }

    onInput(value) {

        this.selectedDate = value;
        this.$emit('update:modelValue', value);

        if(!this.datePickerProps.time && this.autoClose){
            this.dismiss(value);
        }
    }

    dismiss(result = null) {

        this.$emit('dismiss', result);
    }

    cancel() {

        this.dismiss();
    }

    get datePickerProps(): DatePickerProps {
        return this as any
    }
}

export type DatePickerPopupComp = InstanceType<typeof DatePickerPopup>
export type DatePickerPopupProps = ComponentProps<DatePickerPopupComp> & PopupProps & DatePickerProps
export const datePickerPopupCompMixin = createComponentMixin(DatePickerPopup, popupCompMixin, datePickerCompMixin)

</script>